import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import { client } from '../http';

export async function scheduleLinkedinPost({
  unix,
  galleryUsername,
  userID,
  activeTypeshareID,
  attachLink,
  currentSlug,
}) {
  try {
    const { data } = await client.post('/api/scheduling/schedule-linkedin', {
      timestamp: unix,
      data: {
        sentry: {
          username: galleryUsername,
          id: userID,
          postID: activeTypeshareID,
        },
        userID: userID,
        essayID: activeTypeshareID,
      },
    });
    if (!data.success) {
      throw new Error('failed to schedule linkedin post');
    }
    const essayUserRef = firebase
      .database()
      .ref('users/' + userID + '/typeshares/' + activeTypeshareID);

    await essayUserRef.child('linkedinSchedule').update({
      scheduleID: postbackID,
      attachLink,
      link: currentSlug
        ? `https://typeshare.co/${galleryUsername}/posts/${currentSlug}`
        : `https://typeshare.co/${galleryUsername}/posts/${activeTypeshareID}`,
    });

    return { success: true };
  } catch (err) {
    console.error(err);
    return { success: false };
  }
}
